import i18nLocale from "@/helpers/locale";

export const taxIndicationOptions = [
  {
    label: "10%",
    value: 0.1
  },
  {
    label: "8%",
    value: 0.08
  },
  {
    label: i18nLocale("global.dutyFree"),
    value: 0
  },
  {
    label: i18nLocale("global.notApplicable"),
    value: -1.1
  },
];

export const saleTaxOptions = [
  {
    label: "10%",
    value: "percentTen"
  },
  {
    label: "8%",
    value: "percenteight"
  },
  {
    label: i18nLocale("global.dutyFree"),
    value: "zero"
  },
  {
    label: i18nLocale("global.notApplicable"),
    value: "non"
  },
];
